import useQuery from './use-query'
import { useEffect } from 'react'
import { useStores } from 'app/store'
import {
  createAllSeriesPageQuery,
  mapToAllSeriesPageContent,
} from 'app/queries/globals/all-series-page'

const allSeriesPageQuery = createAllSeriesPageQuery()

function useAllSeriesPage() {
  const { lastCollectionStore } = useStores()

  useEffect(() => {
    if (!lastCollectionStore) {
      return
    }
    return lastCollectionStore.reset()
  }, [lastCollectionStore])

  return useQuery(allSeriesPageQuery, {}, mapToAllSeriesPageContent)
}

export default useAllSeriesPage
